import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/stories/accordian/accordian";

const BondsDisclaimer = () => {
    return (
        <div className="w-full bg-neutral-50 md:pb-20 md:pt-20 pt-8 px-6">
            <div className="mx-auto md:w-[1152px] w-full">
                <Accordion type="single" collapsible className="mx-0 w-full md:mx-auto md:w-full">
                    <AccordionItem value="1" className="w-full !border-none">
                        <AccordionTrigger className="mb-4 w-full !border-none !py-0 text-left text-lg font-semibold leading-[25.2px] text-neutral-900">
                            Disclaimer
                        </AccordionTrigger>
                        <AccordionContent className="pb-9 pr-s10 pt-s2 text-left text-sm font-regular leading-[19.6px] text-neutral-500 md:pr-s15">
                            <div>
                                <p>
                                    InCred Money is a technology service provider to Bidd. By
                                    clicking on proceed you agree to the Terms and Conditions.{" "}
                                    <br />
                                    <br />
                                </p>

                                <p>
                                    None of the information displayed on or downloadable
                                    from www.incredmoney.com (the “website”) represents an offer to
                                    buy or sell or a solicitation of an offer to buy or sell any
                                    bond, nor does it constitute an offer to provide investment
                                    advice or service. Registered representatives, subsidiaries,
                                    employees and directors of ETA Fintech Pvt Ltd do not (1)
                                    Advise any member on the merits or advisability of a particular
                                    investment or transaction, or (2) Assist in the determination of
                                    fair value of any investment, or (3) Provide legal, tax, or
                                    transactional advisory services.
                                    <br />
                                    <br />
                                </p>

                                <p>
                                    *Corporate Bonds transactions are executed on Biddeasy.com.
                                    Biddeasy is Online Bond platform provider and registered with
                                    BSE and NSE in the name of Oro Financial Consultants Pvt Ltd.
                                    Oro Financial Consultants Pvt Ltd is the Stock broker entity
                                    operating in cash and debt segment with BSE and Debt segment
                                    with NSE having SEBI registration number: INZ000312534,
                                    Registered as an Online Bond Platform Provider in BSE
                                    Ltd.(Member Code: 6821) and National Stock Exchange of India
                                    Limited (Member Code: 90389)
                                </p>
                            </div>
                        </AccordionContent>
                    </AccordionItem>
                </Accordion>
            </div>
        </div>
    );
};

export default BondsDisclaimer;
